import { render, staticRenderFns } from "./ArtCategories.vue?vue&type=template&id=e0c73104&"
import script from "./ArtCategories.vue?vue&type=script&lang=js&"
export * from "./ArtCategories.vue?vue&type=script&lang=js&"
import style0 from "./ArtCategories.vue?vue&type=style&index=0&id=e0c73104&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports